import { Button, CircularProgress } from "@mui/material";
import React, { memo } from "react";

/**
 * CustomButton — drop-in wrapper around MUI Button.
 *
 * Extra props vs plain <Button>:
 *   loading  {boolean}  — shows a spinner and disables the button
 *   loadingText {string} — text shown while loading (default: same as children)
 */
const CustomButton = ({
    children,
    loading = false,
    loadingText,
    disabled = false,
    startIcon,
    size = "small",
    variant = "contained",
    fullWidth = true,
    ...rest
}) => {
    return (
        <Button
            variant={variant}
            size={size}
            fullWidth={fullWidth}
            disabled={loading || disabled}
            disableElevation
            startIcon={
                loading ? (
                    <CircularProgress
                        size={16}
                        thickness={5}
                        color="inherit"
                        sx={{ mr: 0.5 }}
                    />
                ) : (
                    startIcon
                )
            }
            {...rest}
        >
            {loading ? (loadingText ?? children) : children}
        </Button>
    );
};

export default memo(CustomButton);
